import React, { useState } from "react";
import './altecad.css';
import api from "../../Services/api";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router";
import { FaBars, FaArrowLeft } from 'react-icons/fa';
import Sidebar from '../Sidebar';
import InputMask from 'react-input-mask';
import Moment from 'moment';
import { TextField, Button, Checkbox, FormControlLabel, FormGroup, IconButton, RadioGroup, FormControl, FormLabel, Radio, Select, MenuItem, InputLabel } from '@mui/material';

// Reusable component for questions
const Question = ({ label, value, onChange }) => (
  <FormControl component="fieldset" style={{ marginBottom: '4px' }}>
    <FormLabel component="legend" style={{ textAlign: 'left', fontSize: '0.95rem', margin: 0 }}>
      {label}
    </FormLabel>
    <RadioGroup value={value} onChange={onChange} style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
      <FormControlLabel
        value="1"
        control={<Radio size="small" />}
        label="Sim"
        style={{ width: '20%' }}
      />
      <FormControlLabel
        value="0"
        control={<Radio size="small" />}
        label="Não"
        style={{ width: '20%' }}
      />
    </RadioGroup>
  </FormControl>
);

export const AlterarCadastro = (route) => {
  const showSidebar = () => { setSidebar(!sidebar) };
  const [sidebar, setSidebar] = useState(false);
  const { state } = useLocation();
  const navigate = useNavigate();
  const [idPessoa] = useState(state.id);
  const [nome, setNome] = useState(state.nome);
  const [datanascimento, setDatanascimento] = useState(Moment(state.dataNascimento).format('DD/MM/YYYY'));
  const [cpf, setCpf] = useState(state.cpf);
  const [telefone, setTelefone] = useState(state.telefone);
  const [email, setEmail] = useState(state.email);
  const [altDados, setAltDados] = useState(state.situacao === "0" ? false : true);
  const [atividade, setAtividade] = useState(state.atividade === "0" ? false : true);
  const [cidade, setCidade] = useState(state.cidade);
  const [estado, setEstado] = useState(state.estado);
  const [nomeContatoEmerg, setNomeContatoEmerg] = useState(state.nomeContatoEmerg);
  const [contatoEmerg, setContatoEmerg] = useState(state.contatoEmerg);
  const [pergunta1, setPergunta1] = useState(state.pergunta1);
  const [pergunta2, setPergunta2] = useState(state.pergunta2);
  const [pergunta3, setPergunta3] = useState(state.pergunta3);
  const [pergunta4, setPergunta4] = useState(state.pergunta4);
  const [pergunta5, setPergunta5] = useState(state.pergunta5);
  const [pergunta6, setPergunta6] = useState(state.pergunta6);
  const [pergunta7, setPergunta7] = useState(state.pergunta7);
  const [pergunta8, setPergunta8] = useState(state.pergunta8);
  const [comoConheceu, setComoConheceu] = useState(state.comoConheceu || "");

  const SendAltCad = (e) => {
    e.preventDefault();
    updateCadastro();
  }

  const LimparCampos = () => {
    setNome('');
    setDatanascimento('');
    setCpf('');
    setTelefone('');
    setEmail('');
    setCidade('');
    setEstado('');
    setNomeContatoEmerg('');
    setContatoEmerg('');
    setPergunta1(null);
    setPergunta2(null);
    setPergunta3(null);
    setPergunta4(null);
    setPergunta5(null);
    setPergunta6(null);
    setPergunta7(null);
    setPergunta8(null);
    setComoConheceu('');
  }

  async function updateCadastro() {
    if (nome.length > 0 && datanascimento !== "" && cpf !== "" && email.length > 0 && telefone.length > 0) {
      api.defaults.headers.post = { 'Content-Type': 'application/json' };
      api.defaults.headers.common = { 'x-access-token': localStorage.getItem("token") };

      let cadastro = await EnviaCadastro();

      if (cadastro.status === 200) {
        alert('Cadastro Alterado com sucesso!');
        LimparCampos();
        navigate(-1);
      } else {
        alert('Falha ao alterar cadastro!');
      }
    } else {
      alert('Atenção! Preencha todos os campos');
    }
  }

  async function EnviaCadastro() {
    let response = await api.put(
      '/pessoa/update/', {
        'idPessoa': idPessoa,
        'nome': nome,
        'datanascimento': datanascimento.split('/')[2] + '-' + datanascimento.split('/')[1] + '-' + datanascimento.split('/')[0],
        'cpf': cpf,
        'telefone': telefone,
        'email': email,
        'situacao': altDados ? "1" : "0",
        'anexo': '',
        'cidade': cidade,
        'estado': estado,
        'nomeContatoEmerg': nomeContatoEmerg,
        'contatoEmerg': contatoEmerg,
        'comoConheceu': comoConheceu,
        'pergunta1': pergunta1,
        'pergunta2': pergunta2,
        'pergunta3': pergunta3,
        'pergunta4': pergunta4,
        'pergunta5': pergunta5,
        'pergunta6': pergunta6,
        'pergunta7': pergunta7,
        'pergunta8': pergunta8,
        'atividade': atividade
      }
    );
    return response;
  }

  return (
    <>
      <div className="alterar-cadastro-container">
        <div className="alterar-cadastro-header">
          <FaBars className="menu-icon" onClick={showSidebar} />
          {sidebar && <Sidebar active={setSidebar} />}
          <IconButton onClick={() => navigate(-1)} style={{ marginLeft: 'auto' }}>
            <FaArrowLeft />
            <span style={{ marginLeft: '8px' }}>Voltar</span>
          </IconButton>
        </div>

        <main className="alterar-cadastro-main">
          <fieldset>
            <form onSubmit={SendAltCad} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <TextField
                label="Nome"
                variant="outlined"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                inputProps={{ maxLength: 50 }}
              />
              <InputMask
                mask="99/99/9999"
                value={datanascimento}
                onChange={(e) => setDatanascimento(e.target.value)}
              >
                {() => <TextField label="Data Nascimento" variant="outlined" />}
              </InputMask>
              <InputMask
                mask="999.999.999-99"
                value={cpf}
                onChange={(e) => setCpf(e.target.value.replace(/\D/g, ''))}
              >
                {() => <TextField label="Cpf (Somente Números)" variant="outlined" />}
              </InputMask>
              <InputMask
                mask="(99) 9 9999-9999"
                value={telefone}
                onChange={(e) => setTelefone(e.target.value.replace(/\D/g, ''))}
              >
                {() => <TextField label="Telefone" variant="outlined" />}
              </InputMask>
              <TextField
                label="E-mail"
                variant="outlined"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <TextField
                label="Cidade"
                variant="outlined"
                value={cidade}
                onChange={(e) => setCidade(e.target.value)}
                inputProps={{ maxLength: 100 }}
              />
              <TextField
                label="Estado"
                variant="outlined"
                value={estado}
                onChange={(e) => setEstado(e.target.value.toUpperCase())}
                inputProps={{ maxLength: 2 }}
              />
              <FormControl variant="outlined">
                <InputLabel>Conte pra nós como nos conheceu?</InputLabel>
                <Select
                  value={comoConheceu}
                  onChange={(e) => setComoConheceu(e.target.value)}
                  label="Conte pra nós como nos conheceu?"
                >
                  <MenuItem value="">
                    <em>Selecione uma opção</em>
                  </MenuItem>
                  <MenuItem value="Indicação Hospedagem">Indicação Hospedagem</MenuItem>
                  <MenuItem value="Indicação Restaurante">Indicação Restaurante</MenuItem>
                  <MenuItem value="Indicação Marinheiro">Indicação Marinheiro</MenuItem>
                  <MenuItem value="Ponto de Apoio CENTRO">Ponto de Apoio CENTRO</MenuItem>
                  <MenuItem value="Google">Google</MenuItem>
                  <MenuItem value="Instagram">Instagram</MenuItem>
                  <MenuItem value="TikTok">TikTok</MenuItem>
                  <MenuItem value="YouTube">YouTube</MenuItem>
                  <MenuItem value="Indicação de um parente">Indicação de um parente</MenuItem>
                  <MenuItem value="Outros">Outros</MenuItem>
                </Select>
              </FormControl>
              <TextField
                label="Nome do contato de emergência"
                variant="outlined"
                value={nomeContatoEmerg}
                onChange={(e) => setNomeContatoEmerg(e.target.value)}
                inputProps={{ maxLength: 100 }}
              />
              <InputMask
                mask="(99) 9 9999-9999"
                value={contatoEmerg}
                onChange={(e) => setContatoEmerg(e.target.value.replace(/\D/g, ''))}
              >
                {() => <TextField label="Telefone do contato de emergência" variant="outlined" />}
              </InputMask>
              <Question label="Problemas cardíacos?" value={pergunta1} onChange={(e) => setPergunta1(e.target.value)} />
              <Question label="Gestante?" value={pergunta2} onChange={(e) => setPergunta2(e.target.value)} />
              <Question label="Dificuldades respiratórias ou asma?" value={pergunta3} onChange={(e) => setPergunta3(e.target.value)} />
              <Question label="Desmaios, epilepsia e/ou convulsões?" value={pergunta4} onChange={(e) => setPergunta4(e.target.value)} />
              <Question label="Em período pós-operatório?" value={pergunta5} onChange={(e) => setPergunta5(e.target.value)} />
              <Question label="Problemas ósseos e/ou na coluna vertebral?" value={pergunta6} onChange={(e) => setPergunta6(e.target.value)} />
              <Question label="Estar sob efeito de álcool e/ou entorpecentes?" value={pergunta7} onChange={(e) => setPergunta7(e.target.value)} />
              <Question label="Possui fobia de altura?" value={pergunta8} onChange={(e) => setPergunta8(e.target.value)} />
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={altDados}
                      onChange={(event) =>{setAltDados(event.target.checked)}}
                      inputProps={{ 'aria-label': 'controlled' }}
                    />
                  }
                  label="Email enviado"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={atividade}
                      onChange={(event) =>{setAtividade(event.target.checked)}}
                      inputProps={{ 'aria-label': 'controlled' }}
                    />
                  }
                  label="Partipou da atividade"
                />
              </FormGroup>
              <Button type="submit" variant="contained" color="primary">
                ALTERAR
              </Button>
            </form>
          </fieldset>
        </main>
      </div>
    </>
  )
}